import { Tooltip } from '@mui/material';
import { Pencil, Trash2 } from "lucide-react";
import { Badge } from "src/@/components/ui/badge";
import GenericTable from '../../../../components/table/GenericTable';
import { GENERIC_TABLE_DESIGN } from '../../../../components/table/GenericTable.design';

const TABLE_HEAD = [
  { id: 'recebe', label: 'Recebe', className: 'flex-1' },
  { id: 'setores', label: 'Setores', className: 'w-64 hidden md:block' },
  { id: 'usuarios', label: 'Usuários', className: 'w-64 hidden md:block' },
  { id: 'actions', label: 'Ações', className: 'w-20 text-right' },
];

export default function TableDirecionamentos({ data, onEdit, onDelete }) {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <GenericTable headLabels={TABLE_HEAD}>
      {data.map((row, index) => (
        <div key={row._id || index} className={GENERIC_TABLE_DESIGN.row.container}>
          {/* Recebe - Main col */}
          <div className={GENERIC_TABLE_DESIGN.common.colMain}>
            <h3 className="text-sm font-semibold text-gray-900">{row.recebe}</h3>
          </div>

          {/* Setores */}
          <div className="w-64 hidden md:block px-4">
            <div className="flex flex-wrap gap-1">
              {row.setores && row.setores.map((setor, idx) => (
                <Badge key={idx} variant="secondary" className="mr-1 mb-1 text-[10px] bg-gray-100 text-gray-600 hover:bg-gray-200 border-gray-200">
                  {setor.nome_setor}
                </Badge>
              ))}
            </div>
          </div>

          {/* Usuarios */}
          <div className="w-64 hidden md:block px-4">
            <div className="flex flex-wrap gap-1">
              {row.usuarios && row.usuarios.map((user, idx) => (
                <Badge key={idx} variant="secondary" className="mr-1 mb-1 text-[10px] bg-gray-100 text-gray-600 hover:bg-gray-200 border-gray-200">
                  {user.nomeFantasia}
                </Badge>
              ))}
            </div>
          </div>

          {/* Actions */}
          <div className="w-20 flex justify-end gap-2">
            <Tooltip title="Editar">
              <button
                onClick={() => onEdit(row)}
                className="p-2 rounded-lg text-gray-400 hover:bg-violet-50 hover:text-violet-500 transition-all"
              >
                <Pencil size={18} />
              </button>
            </Tooltip>
            <Tooltip title="Excluir">
              <button
                onClick={() => onDelete(row)}
                className={GENERIC_TABLE_DESIGN.common.deleteButton}
              >
                <Trash2 size={18} />
              </button>
            </Tooltip>
          </div>
        </div>
      ))}
    </GenericTable>
  );
}
